import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react'
import { SaleScaniaPrint } from "../../../../components/SaleScaniaPrint"
import { formatNum, numberParseChina, momentFormat, mergeRepeatArr } from '../../../../utils/util';
import { saleSoService } from '../saleSoService';
import { useSaleSoModel } from '../saleSoModel';
import moment from 'moment';
// import useGlobalModel from '../../../../model/globalModel';
export const SettleScaniaPrints = ({
}) => {
    // // settleScaniaPrint, setSettleScaniaPrint
    // const { shopAndOrg: { shopCode } } = useGlobalModel()
    const { t } = useTranslation();
    const { settleScaniaPrint: visible, selectedRow, setSettleScaniaPrint } = useSaleSoModel()
    const onClose = () => {
        setSettleScaniaPrint(false)
    }
    const print = () => {

    }
    const [formVal, setFormVal] = useState({});
    const [maintenanceList, setMaintenanceList] = useState([]);
    // const [itemList, setItemList] = useState<IItemDetailList[]>([]);
    useEffect(() => {
        visible && getDetailOne()
    }, [visible])
    const getDetailOne = async () => {
        let { retData } = await saleSoService.one(selectedRow.saleCode);
        let { details, createTime, receivedAmount, settleTime, address, ...from } = retData;
        receivedAmount = +formatNum(receivedAmount);
        let mergeDetails = await mergeRepeatArr(details);

        const newMaterialDetails = mergeDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        if (retData) {
            setMaintenanceList(newMaterialDetails ?? []);
            // setItemList(newItemDetails as IItemDetailList[] ?? []);
            setFormVal({
                ...from,
                settleTime: momentFormat(settleTime),
                maintenanceCode: from.saleCode,
                receivableTotalAmount: receivedAmount,
                receivableTotalAmountCN: numberParseChina(receivedAmount),
                enterTime: momentFormat(createTime),
                materialScienceAmount: receivedAmount,
                customerAddress: address
                // discountTotalAmount:discountTotalAmount
            })
        }

    }
    const itemClumns = [
        {
            title: t(`sale.view.settleScaniaPrints.序号`),
            dataIndex: 'No',
        },
        {
            title: t(`sale.view.settleScaniaPrints.项目编号`),
            dataIndex: 'itemCode',
        },
        {
            title: t(`sale.view.settleScaniaPrints.项目名称`),
            dataIndex: 'itemName',
        },
        {
            title: t(`sale.view.settleScaniaPrints.工时`),
            dataIndex: 'workHour',
        },
        {
            title: t(`sale.view.settleScaniaPrints.单价`),
            dataIndex: 'price',
        },
        {
            title: t(`sale.view.settleScaniaPrints.折扣`),
            dataIndex: 'discountRate',
            render: (text) => text + "%"
        },
        {
            title: t(`sale.view.settleScaniaPrints.工时费`),
            dataIndex: 'receivableAmount',
        },
        {
            title: t(`sale.view.settleScaniaPrints.备注`),
            dataIndex: 'note',
        },
    ]
    const columns = [
        {
            title: t(`sale.view.settleScaniaPrints.序号`),
            dataIndex: 'No',
        },
        {
            title: t(`sale.view.settleScaniaPrints.材料编号`),
            dataIndex: 'materialCode',
        },
        {
            title: t(`sale.view.settleScaniaPrints.材料名称`),
            dataIndex: 'materialName',
        },
        {
            title: t(`sale.view.settleScaniaPrints.数量`),
            dataIndex: 'num',
        },
        {
            title: t(`sale.view.settleScaniaPrints.单价`),
            dataIndex: 'price',
        },
        {
            title: t(`sale.view.settleScaniaPrints.折扣`),
            dataIndex: 'discountRate',
            render: (text) => text + "%"
        },
        {
            title: t(`sale.view.settleScaniaPrints.金额`),
            dataIndex: 'amount',
        },
        {
            title: t(`sale.view.settleScaniaPrints.备注`),
            dataIndex: 'note',
        },
    ]
    let IHeader = [
        {
            fieldLabel: `${t(`sale.view.settleScaniaPrints.工号`)}：`,
            fieldValue: formVal.maintenanceCode
        }, {
            fieldLabel: `${t(`sale.view.settleScaniaPrints.支付方式`)}：`,
            fieldValue: formVal.paymentMethodName
        }, {
            fieldLabel: `${t(`sale.view.settleScaniaPrints.打印日期`)}：`,
            fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm")
        },
    ]
    return <SaleScaniaPrint
        title={`${formVal.bentityName} `}
        visible={visible}
        onClose={onClose}
        columns={columns}
        itemClumns={itemClumns}
        itemDataSource={[]}
        dataSource={maintenanceList.filter(item => item.num !== 0)}
        formVal={formVal}
    // shopCode={shopCode}

    />
}